import { Flex, Tag, Text } from '@spotify-internal/encore-web';
import { extractLastNameComponent } from '@spotify/confidence-core-react';
import {
  RuleFragment,
  VariantFragment,
  getTypeOrNull,
} from '@spotify/confidence-graphql';

export const buildVariantUsage = (
  rules: ReadonlyArray<RuleFragment>,
): Record<string, number> => {
  const counts: Record<string, number> = {};
  rules.forEach(rule => {
    rule.assignmentSpec?.assignments?.forEach(assignment => {
      const variantName = getTypeOrNull(assignment.variant?.variant)?.name;
      if (variantName) {
        counts[variantName] = (counts[variantName] ?? 0) + 1;
      }
    });
  });
  return counts;
};

interface VariantItemProps {
  variant: VariantFragment;
  usageCount: number;
}

export const VariantItem = ({ variant, usageCount }: VariantItemProps) => {
  const inUse = usageCount > 0;
  const tagLabel = inUse ? 'In use' : 'Unused';

  return (
    <Flex alignItems="center" gap="tighter-2">
      <Text variant="bodySmall">
        {extractLastNameComponent(variant.name) ?? variant.name}
      </Text>
      <Flex wrap="wrap" gap="tighter-2" aria-label={`${variant.name} usage`}>
        <Tag colorSet={inUse ? 'positiveSubdued' : undefined}>{tagLabel}</Tag>
      </Flex>
    </Flex>
  );
};
